































































































































































































































































import PartnerReportDetailSideCard from "@/components/partner/PartnerReportDetailSideCard.vue";
import DueDateChip from "@/components/project/DueDateChip.vue";
import AssigneePreview from "@/components/utility/AssigneePreview.vue";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { RepairStatusEnum } from "@/lib/enum/repair.enum";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { formatYearsMonthDay, simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { GoToHelper } from "@/lib/utility/goToHelper";
import { handleError } from "@/lib/utility/handleError";
import { ReportGoToHelper } from "@/lib/utility/report.go-to-helper";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { IReport } from "@/models/report.entity";
import { ProgressStatusEnum } from "@/store/enum/partner/progress.status.enum";
import { reportStateMap } from "@/store/mapper/report-icon.map";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { ReportPaginationModule } from "@/store/modules/report-pagination.store";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { PredefinedFilterType } from "../event/filter/event.filter";
import { IInvoiceTotalsByCurrency } from "@/models/invoice-aggregation.entity";
import { ZoneTypeEnum } from "@/lib/enum/zone-type.enum";
import RefsVehicle from "@/components/utility/RefsVehicle.vue";
import RefsHandover from "@/components/utility/RefsHandover.vue";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { IVehicle } from "@/models/vehicle.entity";
import { IHandover } from "@/models/handover.entity";
import { LoadingRefCache } from "@/lib/utility/loading-ref-cache.helper";
import RefsInspection from "@/components/utility/RefsInspection.vue";
import { ITableWrapperHeader } from "@/lib/types/tableWrapper";
import { DataTableCompareFunction } from "vuetify";

@Component({
  components: {
    TheLayoutPortal,
    MHeader,
    PaginatedTable,
    PartnerReportDetailSideCard,
    AssigneePreview,
    DueDateChip,
    RefsVehicle,
    RefsHandover,
    RefsInspection
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class PartnerReportTable extends mixins(PartnerFallbackMixin, PermissionMixin) {
  readonly store = ReportPaginationModule;
  readonly formatCurrency = formatCurrency;
  readonly RepairStatusEnum = RepairStatusEnum;
  readonly ZoneTypeEnum = ZoneTypeEnum;
  readonly vehicleCache = new LoadingRefCache<IVehicle>(this.partnerId, BackendResourceEnum.VEHICLE);
  readonly handoverCache = new LoadingRefCache<IHandover>(this.partnerId, BackendResourceEnum.HANDOVER);

  title = this.$t("navigation.ThePartnerList.report");

  isLoading = false;
  isLoadingUpdate = false;

  selectedItems: IReport[] = [];
  selectedItem: IReport | null = null;
  isLoadingReport = false;
  showSideCard = false;

  get actions(): IAction[] {
    const actions: IAction[] = [];

    actions.push({
      text: this.$t("nav.REPORT_GROUP_TABLE.title").toString(),
      key: "REPORT_GROUP_TABLE",
      disabled: false,
      exec: () =>
        new ReportGoToHelper(this.$router).goToReportGroupTable({
          partnerId: this.partnerId,
          newTab: false
        })
    });

    return actions;
  }

  async mounted() {
    await this.load();
  }

  async load() {
    this.isLoading = true;
    try {
      await this.trySetByRouteOrDefault();
    } catch (error) {
      this.$log.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  getModule() {
    return ReportPaginationModule;
  }

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: this.$t("navigation.ThePartnerList.report"),
      disabled: true,
      exact: true,
      to: {
        name: "PartnerReportTable",
        params: { partnerId: this.partnerId }
      }
    });

    return breadCrumbs;
  }

  get chips() {
    const chips: IAction[] = [];

    chips.push({
      text: `${ReportPaginationModule.totalItems} ${this.$t("navigation.ThePartnerList.report")}`,
      key: "numberOfDocuments"
    });

    return chips;
  }

  get trainPartnerHeaders(): ITableWrapperHeader[] {
    const headers: ITableWrapperHeader[] = [
      {
        text: this.$t("objects.thgMeterReading.status").toString(),
        value: "progressStatus",
        width: "100px"
      },
      {
        text: this.$t("objects.report.isFixed").toString(),
        value: "isFixed",
        width: "110px"
      },
      {
        text: this.$t("project.ticket.assignees").toString(),
        value: "assignees",
        width: "150px"
      },
      {
        text: this.$t("objects.report.title").toString(),
        value: "title",
        width: "200px"
      },
      {
        text: this.$t("finding.contact").toString(),
        value: "companyName"
      },
      {
        text: this.$t("common.nouns.vehicle").toString(),
        value: "vehicleId"
      },
      {
        text: this.$t("objects.vehicle.blueprint.text").toString(),
        value: "position.blueprint.name"
      },
      {
        text: this.$t("handover.title").toString(),
        value: "handover"
      },
      {
        text: this.$t("common.nouns.number").toString(),
        value: "handover.number",
        width: "100px",
        align: "center"
      },
      {
        text: this.$t("inspection.title").toString(),
        value: "handover.foundInInspection"
      },
      {
        text: this.$t("objects.report.timestamp.created").toString(),
        value: "timestamp.created",
        width: "90px",
        type: "date"
      }
    ];

    return headers;
  }

  get headers(): ITableWrapperHeader[] {
    if (this.isTrainPartner) {
      return this.trainPartnerHeaders;
    }
    const headers: ITableWrapperHeader[] = [
      {
        text: this.$t("objects.report.timestamp.created").toString(),
        value: "timestamp.created",
        width: "120px",
        type: "date"
      },
      {
        text: this.$t("common.nouns.number").toString(),
        value: "claimNumber",
        width: "100px"
      },
      {
        text: this.$t("objects.report.status").toString(),
        width: "100px",
        value: "progressStatus"
      },
      {
        text: "",
        value: "status",
        width: "160px"
      },
      {
        text: this.$t("objects.report.isFixed").toString(),
        value: "isFixed",
        width: "105px"
      },
      {
        text: this.$t("project.ticket.assignees").toString(),
        value: "assignees",
        width: "150px"
      },
      {
        text: this.$t("objects.report.title").toString(),
        value: "title",
        width: "120px"
      },
      {
        text: this.$t("objects.report.damageType").toString(),
        value: "damageType",
        width: "150px"
      },
      {
        text: this.$t("objects.report.coverageType").toString(),
        value: "coverageType",
        width: "120px"
      },
      {
        text: this.$t("report.accidentDetails.date").toString(),
        value: "accidentDetails.date",
        width: "120px"
      }
    ];

    if (!this.isFleetPartner) {
      headers.push({
        text: this.$t("objects.report.customerName").toString(),
        value: "customerName",
        width: "200px"
      });

      headers.push({
        text: this.$t("objects.report.companyName").toString(),
        value: "companyName",
        width: "200px"
      });
    }

    headers.push(
      ...[
        {
          text: this.$t("objects.report.repair.status").toString(),
          value: "repair.status",
          width: "150px"
        },
        {
          text: this.$t("objects.report.repair.startDate").toString(),
          value: "repair.startDate",
          width: "140px",
          type: "date",
          align: "end" as "end",
          sort: this.sortByDate
        },
        {
          text: this.$t("objects.report.repair.endDate").toString(),
          value: "repair.endDate",
          width: "140px",
          type: "date",
          align: "end" as "end",
          sort: this.sortByDate
        },
        {
          text: this.$t("objects.report.repair.periodInDays").toString(),
          value: "repair.periodInDays",
          width: "200px",
          align: "center" as "center",
          sort: this.sortByNumber
        },
        {
          text: this.$t("objects.report.workshopCompanyId").toString(),
          value: "workShopCompany.companyName",
          width: "200px"
        }
      ]
    );

    if (!this.isTrainPartner) {
      headers.push(
        ...[
          {
            text: this.$t("objects.towing.title").toString(),
            value: "towing.status",
            width: "150px"
          },
          {
            text: this.$t("objects.report.towingCompanyId").toString(),
            value: "towingCompany.companyName",
            width: "220px"
          }
        ]
      );
    }

    if (this.isWorkshopPartner) {
      headers.push({
        text: this.$t("components.fleet.FleetVehicleDetailDamageCard.headers.damages").toString(),
        value: "damages"
      });

      headers.push({
        text: this.$t("objects.report.message").toString(),
        value: "message"
      });
    }

    headers.push({
      text: this.$t("components.PartnerReportDetail.invoice.revenue").toString(),
      value: "invoiceOutboundAggregation.totals",
      width: "150px",
      sort: this.customSort
    });

    headers.push({
      text: this.$t("components.PartnerReportDetail.invoice.expense").toString(),
      value: "invoiceInboundAggregation.totals",
      width: "150px",
      sort: this.customSort
    });

    headers.push({
      text: this.$t("components.PartnerReportDetail.invoice.balance").toString(),
      value: "invoiceAggregation.totals",
      width: "150px",
      sort: this.customSort
    });

    return headers;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partnerId() {
    return this.$route.params.partnerId;
  }

  get quickFilters(): PredefinedFilterType[] {
    const quickFilters: PredefinedFilterType[] = [];

    quickFilters.push({
      name: "project.ticket.mine",
      filter: [
        new PageFilterElement({
          key: "assignees",
          value: this.userId,
          operation: PageFilterOperationEnum.EQUAL
        })
      ]
    });

    return quickFilters;
  }

  get predefinedFilter(): PredefinedFilterType[] {
    const predefinedFilter: PredefinedFilterType[] = [];

    predefinedFilter.push({
      name: "enums.ProgressStatusEnum.new",
      filter: [
        new PageFilterElement({
          key: "progressStatus",
          value: ProgressStatusEnum.FINISHED,
          operation: PageFilterOperationEnum.NOT_EQUAL
        })
      ]
    });

    predefinedFilter.push({
      name: "project.ticket.mine",
      filter: [
        new PageFilterElement({
          key: "assignees",
          value: this.userId,
          operation: PageFilterOperationEnum.EQUAL
        })
      ]
    });

    predefinedFilter.push({
      name: "project.ticket.overdue",
      filter: [
        new PageFilterElement({
          key: "repair.endDate",
          operation: PageFilterOperationEnum.LESS_EQUAL,
          value: formatYearsMonthDay(new Date())
        })
      ]
    });

    predefinedFilter.push({
      name: "enums.ProgressStatusEnum.finished",
      filter: [
        new PageFilterElement({
          key: "progressStatus",
          value: ProgressStatusEnum.FINISHED,
          operation: PageFilterOperationEnum.EQUAL
        })
      ]
    });

    return predefinedFilter;
  }

  get userId() {
    return UserModule.userId;
  }

  color(progressStatus: ProgressStatusEnum) {
    return reportStateMap.get(progressStatus)?.color || "blue-grey lighten-4";
  }

  async setSelectedItem(item: IReport) {
    this.showSideCard = false;

    try {
      this.isLoadingReport = true;
      this.selectedItem = await PartnerModule.getReportByIdForPartner(item.id);
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoadingReport = false;
    }

    this.$nextTick(async () => {
      this.showSideCard = true;
    });
  }

  closeSideCard() {
    this.showSideCard = false;
    this.selectedItem = null;
  }

  async open(item: IReport) {
    this.$log.debug(item);
    await new GoToHelper(this.$router).goToReportDetail(item.id, item.partnerId);
  }

  async completedSelected() {
    this.isLoadingUpdate = true;
    try {
      const promises = this.selectedItems.map(r => r.updateProgressStatus(ProgressStatusEnum.FINISHED));
      await Promise.all(promises);
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoadingUpdate = false;
    }
  }

  get tableSortDesc() {
    return (this.$refs.reportTable as PaginatedTable<any, any>)?.tableSortDesc;
  }

  customSort(a: IInvoiceTotalsByCurrency[], b: IInvoiceTotalsByCurrency[]) {
    const desc = this.tableSortDesc ?? false;

    if (!a.length) {
      return Number.MAX_SAFE_INTEGER * (desc ? -1 : 1);
    }

    if (!b.length) {
      return -Number.MAX_SAFE_INTEGER * (desc ? -1 : 1);
    }

    const sumA = a.reduce((p, c) => p + c.subtotal, 0) ?? 0;
    const sumB = b.reduce((p, c) => p + c.subtotal, 0) ?? 0;

    return sumA - sumB;
  }

  sortByDate: DataTableCompareFunction<string> = (a: string, b: string) => {
    const desc = this.tableSortDesc ?? false;

    const hasA = !!a;
    const hasB = !!b;

    // If table implements descending by reversing sorted array, pre-compensate:
    // Put missing at top for descending request so reversal keeps them at bottom.
    if (!hasA && !hasB) return 0;
    if (!hasA && hasB) return desc ? -1 : 1;
    if (hasA && !hasB) return desc ? 1 : -1;

    const timeA = new Date(a).getTime();
    const timeB = new Date(b).getTime();
    if (timeA === timeB) return 0;
    // Always sort ascending by date; rely on table's internal reversal for descending
    return timeA < timeB ? -1 : 1;
  };

  sortByNumber: DataTableCompareFunction<string> = (a: string, b: string) => {
    const desc = this.tableSortDesc ?? false;

    const toNum = (v: string | undefined | null) => {
      if (v === undefined || v === null) return undefined;
      const s = String(v).trim();
      if (!s) return undefined;
      const n = Number(s);
      if (isNaN(n)) return undefined;
      return n;
    };

    const numA = toNum(a);
    const numB = toNum(b);

    const hasA = numA !== undefined;
    const hasB = numB !== undefined;

    // Keep empty values always at the bottom irrespective of sort direction.
    if (!hasA && !hasB) return 0;
    if (!hasA && hasB) return desc ? -1 : 1;
    if (hasA && !hasB) return desc ? 1 : -1;

    if (numA === numB) return 0;
    return (numA as number) < (numB as number) ? -1 : 1;
  };
}
